import { IconButton, SvgIcon } from "@mui/material"
import React from "react";


interface EraserButtonProps {
    setSelectedOptions: (options: any[]) => void;
    setInputValue: (value: string) => void;
    onChange: (value: any[]) => void;
    imagePath: string; // Required prop for custom image path
}

const EraserButton: React.FC<EraserButtonProps> = ({
    setSelectedOptions,
    setInputValue,
    onChange,
    imagePath
}) => {

  const clearSelection = () => {
    setSelectedOptions([]);
    setInputValue('');
    onChange([]);
  };

  return (
    <div style={{ display: 'flex', alignItems: 'center'}}>
        <IconButton onClick={clearSelection}>
            <SvgIcon fontSize='small' style={{height: '18px', width: '18px'}} viewBox="0 0 16 16">
            <path d={imagePath} />
            </SvgIcon>
        </IconButton>
    </div>
  )
}

export { EraserButton };